<template>
    <slot :errors="BstkCSVImportData.errors.value">
        <span
            v-bind="$attrs"
            v-for="error in BstkCSVImportData.errors"
            :key="error.index"
        >
            {{ error }}
        </span>
    </slot>
</template>

<script>
    import {inject} from 'vue';

    /* eslint-disable */
    export default {
        name: "BstkCSVFiles",
        setup() {
            const BstkCSVImportData = inject('BstkCSVImportData');

            return {
                BstkCSVImportData,
            }
        },
    };
</script>